
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiChartIsolatedDangers as ObiChartIsolatedDangersElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-chart-isolated-dangers.js';
 
 
 

 
 export const ObiChartIsolatedDangers = createComponent({
   react: React,
   tagName: 'obi-chart-isolated-dangers',
   elementClass: ObiChartIsolatedDangersElement,
   events: {
     
   }
  });
 
 